export function debounce<T extends (...args: any[]) => any>(
	func: T,
	delay: number
): [ThisType<T> & ((...args: Parameters<T>) => Promise<ReturnType<T>>), () => void] {
	let timer: number | undefined;
	return [
		function (...args: any[]) {
			return new Promise((resolve) => {
				clearTimeout(timer);
				timer = window.setTimeout(() => {
					timer = undefined;
					//@ts-ignore
					resolve(func.apply(this, args));
				}, delay);
			});
		},
		() => clearTimeout(timer)
	];
}
